<qpx-layout
    [extraGeneralNavItems]="extraGeneralNavItems()"
    [utilityActions]="utilityActions()"
    [hasUnreadReleaseNotes]="hasUnreadReleaseNotes()"
    [topBarShortcutsByScope]="topBarShortcutsByScope()"
    [manageCompanyShortcut]="manageCompanyShortcut()"
    (findBuildingRequested)="openFindBuilding($event)"
    (whatsNewRequested)="openWhatsNew()"
/>

<ng-template #appTopBarModuleMenu let-close="close" let-shortcuts="shortcuts">
    <nav class="app-top-bar-menu scope-menu" aria-label="App modules">
        <section class="module-group" aria-labelledby="app-menu-primary">
            <h2 id="app-menu-primary" class="group-title">App</h2>
            <ul class="module-list">
                <li>
                    <a
                        class="module-item"
                        routerLink="/"
                        routerLinkActive="active"
                        ariaCurrentWhenActive="page"
                        [routerLinkActiveOptions]="{ exact: true }"
                        data-app-top-bar-autofocus
                        (click)="close('navigation')"
                    >
                        <ng-icon qpx name="lucideHouse" />
                        <span class="item-copy">
                            <span class="item-label">Home</span>
                            <span class="item-description">
                                Start your work in Quipex
                            </span>
                        </span>
                    </a>
                </li>
                @if (portfolioChatAvailable()) {
                    <li>
                        <a
                            class="module-item qpx-nav-button-ai-mode qpx-sparkle"
                            routerLink="/chat"
                            routerLinkActive="active"
                            ariaCurrentWhenActive="page"
                            (click)="close('navigation')"
                        >
                            <ng-icon qpx name="lucideSearch" />
                            <span class="item-copy">
                                <span class="item-label">Ask Quippy</span>
                                <span class="item-description">
                                    Ask questions across your portfolio
                                </span>
                            </span>
                        </a>
                    </li>
                }
                <li>
                    <a
                        class="module-item"
                        routerLink="/buildings"
                        routerLinkActive="active"
                        ariaCurrentWhenActive="page"
                        [routerLinkActiveOptions]="{ exact: true }"
                        (click)="close('navigation')"
                    >
                        <ng-icon qpx name="lucideBuilding2" />
                        <span class="item-copy">
                            <span class="item-label">My buildings</span>
                            <span class="item-description">
                                Find and manage buildings
                            </span>
                        </span>
                    </a>
                </li>
            </ul>
        </section>

        @if (shortcuts.length) {
            <section class="shortcuts" aria-labelledby="app-menu-shortcuts">
                <h2 id="app-menu-shortcuts" class="sr-only">Shortcuts</h2>
                @for (shortcut of shortcuts; track shortcut.key) {
                    <a
                        class="shortcut-item"
                        [routerLink]="shortcut.route"
                        (click)="close('navigation')"
                    >
                        <ng-icon qpx [name]="shortcut.icon" />
                        <span class="item-copy">
                            <span class="item-label">{{ shortcut.label }}</span>
                            @if (shortcut.description) {
                                <span class="item-description">{{
                                    shortcut.description
                                }}</span>
                            }
                        </span>
                        <ng-icon qpx name="lucideArrowRight" />
                    </a>
                }
            </section>
        }
    </nav>
</ng-template>
